module.exports = __webpack_public_path__ + "static/pic01-a327a60579bff458e222d063d309df90.jpg";